export default __webpack_public_path__ + "img/temp-machine.asset.4fae5c1b.jpg";